import TagManager from './TagManager'

export default TagManager